import { useTranslation } from 'react-i18next';

import { Page } from '@/ui-kit/templates/Page';
import { AllCardsTable } from '@/features/cards/components/AllCards/AllCardsTable';

export function CardsPage() {
  const { t } = useTranslation();
  return (
    <Page title={t('layout.sidebar.links.cards')}>
      <AllCardsTable />
    </Page>
  );
}

export default CardsPage;
